import { Field } from 'formik';
import React, { type ReactElement } from 'react';

export interface ISelectOption {
  value: string;
  label: string;
}

function Select({
  errorMessage = undefined,
  name,
  label,
  withDefaultOption = true,
  options = [],
  placeholder = '',
  onBlur,
}: {
  errorMessage?: string;
  name: string;
  label: string;
  withDefaultOption?: boolean;
  options?: ISelectOption[];
  placeholder?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}): JSX.Element {
  const hasError: boolean = !!errorMessage;

  return (
    <label htmlFor={name} className={hasError ? 'error' : 'valid'}>
      {label}

      <Field
        as="select"
        id={name}
        name={name}
        className={hasError ? 'error' : 'valid'}
        onBlur={onBlur}
        placeholder={placeholder}
      >
        {withDefaultOption && (
          <option key="default" value="">
            {placeholder}
          </option>
        )}
        {options.map(
          (option: ISelectOption): ReactElement => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ),
        )}
      </Field>

      <p className={`errorMessage ${errorMessage ? 'error' : 'valid'}`}>
        {errorMessage || '&nbsp;'}
      </p>
    </label>
  );
}

export default Select;
